export const buildNumber = '20260324.5';
export const version = 'main';
export const latestCommit = 'e223d0fb50bd2248220140cfb658893081a7dbba';
